import $ from 'domtastic'
import { isAuthenticated, getAuthUrl } from './auth'

class Modal {
  constructor() {
    this.initializeModal()
    this.modalOpen = false
  }

  closeModal() {
    document.querySelectorAll('.module.modal').forEach((x) => {
      x.classList.remove('is-open')
      $(x).find('form .input-error').removeClass('input-error')
      $(x).find('form .error-message').remove()
    })

    document.body.classList.remove('is-modal-open')
    
    this.modalOpen = false
  }

  openModal($modal) {
    // close already-open modals
    $('.module.modal.is-open').trigger('close')

    $modal.addClass('is-open')

    if (!document.body.classList.contains('is-modal-open')) {
      document.body.classList.add('is-modal-open');
    }

    var $this = this
    setTimeout(function () {
      $this.modalOpen = !$this.modalOpen
    }, 400)
  }

  initializeModal() {
    var $this = this

    // esc clicked
    // document.onkeydown = function (evt) {
    //   evt = evt || window.event
    //   var isEscape = false
    //   if ('key' in evt) {
    //     isEscape = evt.key === 'Escape' || evt.key === 'Esc'
    //   } else {
    //     isEscape = evt.keyCode === 27
    //   }
    //   if (isEscape) {
    //     // console.log('here')
    //     $this.closeModal()
    //   }
    // }

    // Listen for the event.
    window.addEventListener(
      'back-to-default',
      function (e) {
        $this.closeModal()
      },
      false
    )

    function validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }

    // modal cta
    var $modalCTA = document.querySelectorAll('.modal-cta')
    for (const cta of $modalCTA) {
      cta.addEventListener('click', function (event) {
        event.preventDefault()

        const target = event.currentTarget.getAttribute('data-modal')
        const $modal = $(`.${target}`)

        // authorize check
        if (
          event.currentTarget.hasAttribute('data-modal-authorize') &&
          !isAuthenticated()
        ) {
          window.location.href = getAuthUrl()
          return
        }

        // title
        const title = event.currentTarget.getAttribute('data-modal-title')
        if (title && title.length) {
          $modal.find('.modal-title').text(title)
        }

        // state
        const state = event.currentTarget.getAttribute('data-modal-state')
        if (state && state.length) {
          $modal.find(`[data-state=${state}]`).css('display', 'block')
        } else {
          $modal.find(`[data-state]`).css('display', 'none')
        }

        $this.openModal($modal)
      })
    }

    // Modal close and cancel
    document
      .querySelectorAll('.module.modal .cancel-cta,.module.modal .close-cta')
      .forEach(($el) =>
        $el.addEventListener('click', function (e) {
          e.preventDefault()

          if (!$(this).hasClass('disabled')) {
            $this.closeModal()
            return false
          }
        })
      )

    // click outside
    document.addEventListener('click', function (event) {
      const $modalWrapper = document.querySelector(
        '.module.modal.is-open .wrapper'
      )
      if ($modalWrapper) {
        const isClickInside = $modalWrapper.contains(event.target)
        const isDisabled = $modalWrapper.classList.contains('disabled')

        if (!isClickInside && $this.modalOpen && !isDisabled) {
          $this.closeModal()
        }
      }
    })

    // close
    $('.module.modal').on('close', function () {
      $this.closeModal()
    })

    // open
    $('.module.modal').on('open', function (event) {
      const $modal = $(event.currentTarget)

      $this.openModal($modal)
    })

    // disable/enable
    $('.module.modal').on('disable', function () {
      $(this).find('fieldset').attr('disabled', true)
      $(this).find('button[type=submit]').attr('disabled', true)
      $(this).find('.close-cta, .cancel-cta').addClass('disabled')
      $(this).find('.wrapper').addClass('disabled')
    })
    $('.module.modal').on('enable', function (e) {
      const modalOnly = e.detail && e.detail.modalOnly;
      if (!modalOnly) {
        $(this).find('fieldset').removeAttr('disabled', false)
        $(this).find('button[type=submit]').removeAttr('disabled', false)
      }
      $(this).find('.close-cta, .cancel-cta').removeClass('disabled')
      $(this).find('.wrapper').removeClass('disabled')
    })

    let values = {}

    $('.module.modal form').on('submit', function (e) {
      e.preventDefault()
      const formInputs = $(this).find('[name]')

      formInputs.map((el) => {
        values[$(el)[0].attributes['name'].value] = $(el).val()

        if (!$(el).val().length && $(el).attr('data-input-required')) {
          $(el).parent().addClass('input-error')
          $(el).parent().append(`<div class="error-message">
                          Input required!
                      </div>`)
        }

        if ($(el).val().length && $(el).attr('data-input-required')) {
          $(el).parent().removeClass('input-error')
          $(el).parent().find(`.error-message`).remove()
        }

        if (
          $(el).val().length &&
          $(el).attr('type') === 'email' &&
          !validateEmail($(el).val())
        ) {
          $(el).parent().addClass('input-error')
          $(el).parent().append(`<div class="error-message">
                          Input must be a valid email address.
                      </div>`)
        }
      })
    })

    $('.module.modal form [name]').on('blur', function (e) {
      e.preventDefault()
      values[$(this)[0].attributes['name'].value] = $(this).val()

      if (!$(this).val().length && $(this).attr('data-input-required')) {
        $(this).parent().addClass('input-error')
        $(this).parent().append(`<div class="error-message">
                        Input required!
                    </div>`)
      }

      if ($(this).val().length && $(this).attr('data-input-required')) {
        $(this).parent().removeClass('input-error')
        $(this).parent().find(`.error-message`).remove()
      }

      if (
        $(this).val().length &&
        $(this).attr('type') === 'email' &&
        !validateEmail($(this).val())
      ) {
        $(this).parent().addClass('input-error')
        $(this).parent().append(`<div class="error-message">
                        Input must be a valid email address.
                    </div>`)
      }
    })

    $('.custom-form-item input').on('blur', function () {
      let val = $(this)[0].value

      if (val.length > 0) {
        $(this).parent().find('.custom-placeholder').addClass('static')
        $(this).parent().addClass('fill')
        $(this).parent().removeClass('empty')
      } else {
        $(this).parent().find('.custom-placeholder').removeClass('static')
        $(this).parent().addClass('empty')
        $(this).parent().removeClass('fill')
      }
    })

    $('.custom-form-item textarea').on('blur', function () {
      let val = $(this)[0].value

      if (val.length > 0) {
        $(this).parent().find('.custom-placeholder').addClass('static')
      } else {
        $(this).parent().find('.custom-placeholder').removeClass('static')
      }
    })
  }
}

export default Modal
